import { useCallback } from "react";
import * as yup from 'yup';

import { CreateClaimDto } from '@/modules/UseMyMoney/queries';
import { ClaimValidationError, UseMyMoneyOption } from '@/modules/UseMyMoney/UseMyMoney.types';

const reimburseMeSchema = yup.object().shape({
  amount: yup.string().required(),
  providerId: yup.string().required(),
  patientId: yup.string().required(),
  dateOfService: yup.string().required(),
  serviceId: yup.string().required(),
  notes: yup.string().max(300).notRequired(),
  documentId: yup.string().notRequired(),
  ocrReceiptId: yup.string().notRequired(),
  paymentMethodId: yup.string().required(),
  payToType: yup.string().required(),
  paymentType: yup.string().required(),
});

const payAProviderSchema = yup.object().shape({
  amount: yup.string().required(),
  providerId: yup.string().required(),
  patientId: yup.string().required(),
  dateOfService: yup.string().required(),
  serviceId: yup.string().required(),
  notes: yup.string().max(300).notRequired(),
  accountNumber: yup.string().max(200).notRequired(),
  invoiceNumber: yup.string().max(200).notRequired(),
  documentId: yup.string().notRequired(),
  ocrReceiptId: yup.string().notRequired(),
  paymentMethodId: yup.string().required(),
  payToType: yup.string().required(),
  paymentType: yup.string().required(),
});

const hsaWithdrawalSchema = yup.object().shape({
  amount: yup.string().required(),
  paymentMethodId: yup.string().required(),
  accountId: yup.string().required(),
  notes: yup.string().max(300).notRequired(),
  documentId: yup.string().notRequired(),
});

const useValidateClaim = () => {
  // @ts-ignore
  const validate = useCallback((claimData?: CreateClaimDto, schema?: yup.ObjectSchema) => {
    try {
      schema.validateSync(claimData, { abortEarly: false });
      return [] as ClaimValidationError[];
    } catch (error) {
      if (error instanceof yup.ValidationError) {
        return error.errors as ClaimValidationError[];
      }
      return [] as ClaimValidationError[];
    }
  }, []);

  const validateClaim = useCallback((useMyMoneyOption?: UseMyMoneyOption, claimData?: CreateClaimDto): ClaimValidationError[] => {
    switch (useMyMoneyOption) {
      case UseMyMoneyOption.REIMBURSE_MYSELF:
        return validate(claimData, reimburseMeSchema);
      case UseMyMoneyOption.PAY_A_PROVIDER:
        return validate(claimData, payAProviderSchema);
      case UseMyMoneyOption.HSA_WITHDRAWAL:
        return validate(claimData, hsaWithdrawalSchema);
      default:
        return [ClaimValidationError.OPTION_REQUIRED];
    }
  }, [validate]);

  return {
    validateClaim,
  };
};

export default useValidateClaim;
